/*
 * Hook para pedir datos al servidor con estado de carga, error y reintento, sin pasar por redux (el
 * store se guarda completo en localStorage con redux-persist y las jornadas de un mes pesan mucho).
 *
 * Uso:
 *     const workdays = useRemoteData(() => fetchWorkdays(token, params), token ? JSON.stringify(params) : null);
 *     workdays.status   // 'idle' | 'loading' | 'ok' | 'error'
 *     workdays.data     // lo que resuelve la promesa (p. ej. {cantidad, datos})
 *     workdays.message  // mensaje de error en español (utils/errors.js)
 *     workdays.reload() // vuelve a pedir lo mismo (botón "Reintentar")
 *
 * `requestKey` decide cuándo volver a pedir: cambia la clave => nueva petición; null => no pide (idle).
 * Una respuesta que llega después de cambiar la clave se descarta (no pisa datos más nuevos).
 */
import {useEffect, useState} from "react";
import {errorMessage} from "../utils/errors";

export default function useRemoteData(loader, requestKey) {
    const [state, setState] = useState({status: 'idle', data: null, message: ''});
    const [attempt, setAttempt] = useState(0);

    useEffect(() => {
        if (!requestKey) {
            setState({status: 'idle', data: null, message: ''});
            return undefined;
        }
        let active = true;
        setState((previous) => ({...previous, status: 'loading', message: ''}));
        loader()
            .then((data) => {
                if (active) setState({status: 'ok', data, message: ''});
            })
            .catch((error) => {
                if (active) setState({status: 'error', data: null, message: errorMessage(error)});
            });
        return () => {
            active = false;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [requestKey, attempt]);

    return {...state, reload: () => setAttempt((value) => value + 1)};
}
